module.exports = __webpack_public_path__ + "img/USAAC_Roundel_1919-1941.svg.a7f8673c.png";